import * as actions from './actionType';

export const getErros = errors => ({
  type: actions.GET_SERVER_ERRORS,
  errors,
});
